<script>
export default {
    name: 'Paginated',
    props: {
        data: {
            type: Array,
            required: true
        },
        columns: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        total: {
            type: Number,
            required: true
        }
    },
    created () {
        this.checkPage()
    },
    watch: {
        data () {
            this.checkPage()
        }
    },
    methods: {
        checkPage () {
            if (this.data.length == 0 && this.value._page > 1) {
                this.changePage(this.value._page - 1)
            }
        },
        changeSort (new_sort) {
            this.$emit('input', {
                ...this.value,
                _sort: new_sort,
                _asc: this.value._sort == new_sort ?
                    this.value._asc == 1 ?
                        0 :
                        1 :
                    this.value._asc
            })
        },
        changePage (new_page) {
            this.$emit('input', {
                ...this.value,
                _page: new_page
            })
        }
    },
    computed: {
        pages () {
            return Math.ceil(this.total / this.value._limit)
        }
    }
}
</script>
